import React from "react";
import "./hero.css";

const HeroSection = () => {
  return (
    <section className="hero-section-homeherosectioncc">
      {/* Rotating background */}
      <div className="hero-bg-rotate-homeherosectioncc"></div>

      {/* Zodiac Circle Image Placeholder (optional, can remove if not needed) */}
      <div className="zodiac-placeholder-homeherosectioncc"></div>

      {/* Main Heading */}
      <h1 className="hero-heading-homeherosectioncc">
        Revealing the Story <br />  Written in Your<span>Stars</span>
      </h1>

      {/* Subtext */}
      <p className="hero-subtext-homeherosectioncc">
Get clear, personalized guidance for your career, love life, health, and destiny.
CosmicalCalculator — the one place where all your questions find their answers      </p>

      <a href="Book-your-slot"><button className="hero-button-homeherosectioncc">Get My answers now</button></a>
      {/* CTA Button */}
    </section>
  );
};

export default HeroSection;
